//Hooplandia Theme --------------------------------------------------
$(document).ready(function () {
  // SubTheme class to search page

  let prevPage = document.referrer.split('/');
  if (prevPage[4] == 'hooplandia' && window.location.pathname == '/search.aspx') {
    $('body').addClass('hooplandiaTheme');
  }
});


function modifySearch() {
  const iconSVG = `<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" fill="#fff" viewBox="0 0 512 512">
  <path
    d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z"
  />
</svg>`
  $('.button.inputFieldSubmit.searchSubmitButton').html(iconSVG);
}

function modifyLogin() {
  const userSVG =
  `<svg xmlns="http://www.w3.org/2000/svg" height="16" width="14" viewBox="0 0 448 512">
  
  <path
    fill="#ffffff"
    d="M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512l388.6 0c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304l-91.4 0z"
  />
</svg>
`;
  $('header .loginstatus-change').html(userSVG);
} 

function modifyTopLinks() {
  modifySearch();
  modifyLogin();
}

function modifyBtnNavToggle() {
  const navToggle = document.querySelector('.mobile-nav-toggle');

  navToggle.innerHTML = `
    <span></span>
    <span></span>
    <span></span>
  `;
  navToggle.setAttribute('tabindex', '0');
  navToggle.setAttribute('role', 'button');
  navToggle.setAttribute('aria-label', 'open menu');
}

function foodFinderChanges() {
  if ($('.BusinessCategoryModule a').first().text() == 'Food Finder') {
    $('#imgsearch').css('display', 'none');
    $('#mapContainer .mapLegend').css('display', 'none');
  } else {
    return false;
  }
}

function cloneLogo() {
  const logo = $('.header .header-logo').clone().addClass('logo-footer-img');
  $('.logo-footer').prepend(logo);
}


// --------------------Feature Lineup----------------------//

function modifyFeatureLineup() {
  function cropText(text, maxLength) {
    return text.length > maxLength ? text.substring(0, maxLength) : text;
  }

  function createContentWrapper(titleText, croppedTitle, descriptionText) {
    return `
      <h4 title="${titleText}" aria-label="${titleText}">${croppedTitle}</h4>
      ${descriptionText ? `<span class="feature-description">${descriptionText}</span>` : ''}
    `;
  }

  $('.featureLineupContainer').each((i, element) => {
    const $element = $(element);
    const $imageContainer = $element.find('.featureLineupImage');
    const $title = $element.find('.featureLineup-title');
    const $description = $element.find('.featureLineup-text').last();
    const $moreBtn = $element.find('.featureLineup-more');

    const titleText = $title.text().trim();
    const descriptionText = $description.text().trim();
    const croppedDescription = cropText(descriptionText, 120);
    const croppedTitle = cropText(titleText, 35);

    const contentWrapper = createContentWrapper(titleText, croppedTitle, croppedDescription);
    const wrapperAux = `<span class="featureLineup-text">${contentWrapper}</span>`;

    $title.remove();
    $moreBtn.find('.button').addClass('button-small')

    if ($description.length) {
      $description.html(contentWrapper);
      $description.append($moreBtn);
    } else {
      $imageContainer.append(wrapperAux);
      $imageContainer.find('.featureLineup-text').append($moreBtn);
    }
  });
}

// --------------------Menu dropdown animation----------------------//

function dropdownAnimation() {
  $(".groups .group").each(function () {
    let nmbrSlides = 1;
    $(this)
      .find(".items > .item")
      .each(function () {
        let nmbrSubSlides = 1;
        $(this).addClass(`dropdown_menu-${nmbrSlides}`);
        $(this).find(".navClonedItem").remove();
        nmbrSlides++;

        $(this)
          .find(".subitems > .item")
          .each(function () {
            $(this).addClass(`dropdown_submenu-${nmbrSubSlides}`);
            $(this).find(".navClonedItem").remove();
            nmbrSubSlides++;
          });
      });
  });
}

// --------------------Hero image inner pages----------------------//



function dynamicHero() {
  const imageModule = $('.entityContainer .entityContainerRow.rowIndex-1').find('.imageModule-single img');
  const image = imageModule.attr('data-src');
  const title = $('.entityContainer .entityContainerRow.rowIndex-1').find('.dynamicPageTitle');
  const imageSrc = image.replace(/(?=[() ])/g, '\\');
  const heroHTML = `<div class="hero-wrapper" style="background-image: url(${imageSrc})"></div>`;
  if (image) {
    $(heroHTML).prependTo('.wrapper');
    $('.hero-wrapper').append(title);
    $(imageModule).remove();
  } else {
    return false;
  }

}


function bigEScripts() {
  $('.header').addClass('header-bige')
  dropdownAnimation();
  modifySearch();
  modifyLogin();
  modifyBtnNavToggle();
  cloneLogo();

  if ($('.featureLineupModule').length) {
    modifyFeatureLineup();
  }

    
  // add hero image to inner pages
  if ($('body').hasClass('hero-image')) {
    dynamicHero();
  }
}

$(document).ready(function () {
  const header = $('.header');
  // prepend generalmessage to header
  $('.generalmessage').prependTo(header);

  // if the url ends with /csstest.aspx then add class 'theBigE' to the body
  if (window.location.pathname.endsWith('/csstest.aspx')) {
    $('body').addClass('theBigE');
  }

  const isBigE = !$('body').hasClass('hooplandiaTheme') && !$('body').hasClass('hooplandiaSubTheme')

  // if body has not class hooplandiaTheme or hooplandiaSubTheme execute cloneLogo()

  if (isBigE) {
    bigEScripts()
  }


  // set footer saffire logo image
  $('.footer .saffire_logo').attr('src', `${FULLCLIENTTHEMEPATH}images/saffire-logo.png`);

  $(window).load(function () {
  
    if(isBigE) {
      modifyTopLinks()
    }
    // misc subpage stuff
    foodFinderChanges();
  
    // remove button class from footer nav links
    if ($('body').hasClass('saffireMobileSize')) {
      $('.footerItems1 li a').removeClass('button');
    }
  });
  
});



$(window).resize(function () {
  // remove button class from footer nav links
  if ($('body').hasClass('saffireMobileSize')) {
    $('.footerItems1 li a').removeClass('button');
  }
});


// DefaultTheme

$("document").ready(function() {
  function addDefaultThemeExtra() {
  const defaulTheme = 'theBigE';
  const bigELandingTheme = 'bigELanding';
  const goldenTheme = 'subpage-golden-ticket';
  const hooplandiaTheme = 'hooplandiaTheme';
  if (!$('body').hasClass(bigELandingTheme) && !$('body').hasClass(goldenTheme) && !$('body').hasClass(hooplandiaTheme)) {
    $('body').addClass(defaulTheme);
  }
}
addDefaultThemeExtra();
});